import React from "react";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";

import OthersList from "./components/OthersList";
import OthersPresenter from "./OthersPresenter";
import { dialog } from "../../nq-component";
import { footer, html } from "framer-motion/client";
import DialogCreate from "./components/DialogCreate";

class OthersPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, others: [], advanced: false };
    this.presenter = new OthersPresenter(
      this,
      getObjectUseCase(),
      findObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "others";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleSubmit(object) {
    console.log("zxzx", object);
    const { others } = this.state;
    this.presenter.handleSubmit(object, others);
  }

  handleClick(object) {
    dialog.fire({
      html: (
        <DialogCreate
          objects={object}
          handleChange={this.onChange.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
          handleClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  render() {
    const { others } = this.state;

    return (
      <>
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex  align-items-center p-3">
                <h2
                  className="fw-bold text-capitalize mb-0"
                  style={{ color: "#d18237" }}
                >
                  <i
                    className="bi bi-arrow-left me-2"
                    onClick={this.onClickBack.bind(this)}
                  ></i>
                  Others
                </h2>
              </div>

              <div
                className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4"
                style={{
                  borderTop: "8px solid #d18237",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    <OthersList
                      others={others}
                      handleClick={this.handleClick.bind(this)}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(OthersPage);
